// Keycard custom layer: load store-specific behaviors without touching upstream bundles.

import './keycard-header-toggle.js';
// keycard-reader-auto-add.js disabled:
// the theme previously auto-added a free hardware reader when certain Keycard items
// were present in the cart. This behavior is intentionally turned off now.

// The Shell "New" badge has been retired site-wide.
